import { useState } from 'react';

import { AppContext, defaultAppConfig } from './AppContext';

interface AppContextProviderProps {
  children: React.ReactNode;
}
export const AppConfigProvider = ({ children }: AppContextProviderProps) => {
  const [appConfig, setAppConfig] = useState(defaultAppConfig); // The state to manage

  // The value provided to consumers will contain both the value and the updater
  const contextValue = {
    appConfig,
    setAppConfig,
  };

  return <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>;
};
